<template>
  <div>
    <RightTitle title="我的关注"></RightTitle>
    <FriendTab position="visit"></FriendTab>

    <!-- 列表 -->
    <div class="uar_form">
      <div class="uarf_imglist clear">
        <div v-if="dataTotal > 0">
          <div class="list" v-for="(item, index) in tableData" :key="index">
            <div class="head">
              <el-tooltip :content="item.nick">
                <a :href="item.spaceUrl" target="_blank">
                  <img :src="item.head" />
                </a>
              </el-tooltip>
            </div>
            <div class="nick inlineShow">
              <el-tooltip :content="item.nick">
                <a :href="item.spaceUrl" target="_blank">{{ item.nick }}</a>
              </el-tooltip>
            </div>
            <div class="oprt">
              <span>{{ item.addTime }}</span>
            </div>
          </div>
        </div>
        <div class="noResult" v-else>暂无数据</div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="uar_form page_area" v-if="dataTotal > 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="dataTotal"
        :page-size="20"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// 加载组件
import RightTitle from "../../components/RightTitle";
import FriendTab from "../../components/FriendTab";
// 加载api
import { visit } from "../../api/friend";
export default {
  name: "friend_visit",
  components: {
    RightTitle,
    FriendTab
  },
  beforeRouteEnter(to, from, next) {
    visit(to.query).then(res => {
      next(vm => {
        vm.tableData = res.data.list;
        vm.dataTotal = res.data.count;
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    visit(to.query).then(res => {
      this.tableData = res.data.list;
      this.dataTotal = res.data.count;
    });
    next();
  },
  data() {
    return {
      tableData: [],
      dataTotal: 0
    };
  },
  methods: {
    // 改变当前页
    currentChange(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    }
  }
};
</script>

<style scoped>
</style>